// extracted by mini-css-extract-plugin
module.exports = {"ctaContainer":"FooterCTA_ctaContainer__yFaIY"};